import React, { useState } from "react";
import AddLocationModal from "./AddLocationModal";
import LocationTable from "./LocationTable";
import AnalyticsCard from "./AnalyticsCard";
import { useNavigate } from "react-router-dom";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import {
  allPharmacyAtom,
  clinicAtom,
} from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";

const PharmacyDashboard = () => {
  const [showModal, setShowModal] = useState(false);
  const [clinic, setClinic] = useAtom(clinicAtom);
  const [allPharmacy, setAllPharmacy] = useAtom(allPharmacyAtom);
  const navigate = useNavigate("");

  console.log("All Pharmacy", allPharmacy);

  const { data } = useItemsFilter(
    ApiEndPoint.PHARMACY,
    `?action=getPharmacy&clinic_id=${clinic.id}`,
    clinic.id ? true : false
  );

  // Calculate analytics data
  const totalLocations = data?.length || 0;
  const retailLocations =
    data?.filter((item) => item.type === "Retail")?.length || 0;
  const wholesaleLocations =
    data?.filter((item) => item.type === "Wholesale")?.length || 0;

  // console.log(data);

  return (
    <div className="bg-gray-100 min-h-screen p-8">
      <header className="mb-8 flex items-center justify-between">
        <h1 className="text-3xl font-bold text-gray-800">Pharmacy Dashboard</h1>
        {data?.length > 0 && (
          <button
            className="bg-green-500 text-white px-6 py-2 rounded shadow hover:bg-green-600 transition"
            onClick={() => navigate("/new/setup/warehouse/new")}
          >
            Add New Location
          </button>
        )}
      </header>

      {/* Analytics Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <AnalyticsCard
          title="Total Locations"
          value={totalLocations}
          color="text-green-500"
        />
        <AnalyticsCard
          title="Retail Locations"
          value={retailLocations}
          color="text-blue-500"
        />
        <AnalyticsCard
          title="Wholesale Locations"
          value={wholesaleLocations}
          color="text-yellow-500"
        />
      </div>

      {/* Location Table */}
      <LocationTable locations={data?.length > 0 ? data : allPharmacy} />
    </div>
  );
};

export default PharmacyDashboard;
